import { render, staticRenderFns } from "./MoleculeResetPassword.vue?vue&type=template&id=65f8396f"
import script from "./MoleculeResetPassword.vue?vue&type=script&lang=js"
export * from "./MoleculeResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports